import LocalStorageCollection from "@src/backbone/prototypes/LocalStorageCollection";
import HybridRoutingModel from "@src/backbone/model/HybridRoutingModel";

class HybridRoutingCollection extends LocalStorageCollection<HybridRoutingModel> {
  name = "HybridRoutingCollection";
  route = "apiHybridRoutingCollection";
  idAttribute = "id_front_controller";
}
export default HybridRoutingCollection;
